import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursorArrowFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M2.22 2.22a.75.75 0 0 1 .806-.167l14.5 5.75a.75.75 0 0 1 .16 1.307l-2.78 1.986 2.874 2.874a.75.75 0 0 1 0 1.06l-2.75 2.75a.75.75 0 0 1-1.06 0l-2.874-2.874-1.986 2.78a.75.75 0 0 1-1.307-.16l-5.75-14.5a.75.75 0 0 1 .167-.806Z"
	})]
});
const ForwardRef = forwardRef(SvgCursorArrowFill);
export { ForwardRef as ReactComponent };
